import { useState } from 'react';

const STATIC_REGIONS_DISTRICTS = {
  'Mudug': ['Galkacyo', 'Jariiban', 'Goldogob'],
  'Bari': ['Bosaso', 'Carmo', 'Ufeyn', 'Iskushuban', 'Qandala'],
  'Karkaar': ['Qardho', 'Benderbayla', 'Rako', 'Waaciya', 'Xaafuun'],
  'Nugaal': ['Garowe', 'Burtinle', 'Eyl', 'Dongorayo', 'Godobjiraan'],
  'Raascaseyr': ['Caluula', 'Baargaal'],
  'Sanaag': ['Badhan', 'Xingalool', 'Laasqoray'],
  'Sool': ['Bocame', 'Hudun', 'Lascanood', 'Taleex', 'Tukaraq'],
  'Cayn': ['Buhoodle', 'Horufadhi', 'Widhwidh'],
  'Haylaan': ['Dhahar']
};

export const useStaticRegionDistricts = () => {
  const [filteredDistricts, setFilteredDistricts] = useState([]);

  const regions = Object.keys(STATIC_REGIONS_DISTRICTS);

  const handleRegionChange = (regionName) => {
    const districts = STATIC_REGIONS_DISTRICTS[regionName] || [];
    setFilteredDistricts(districts);
  };

  return {
    regions,
    filteredDistricts,
    handleRegionChange
  };
};
